import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { styled } from '@mui/material/styles';
import {
  Box,
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  Menu,
  MenuItem,
  ListItemText
} from '@mui/material';
import { useRef, useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

UserListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func
};


export default function UserListToolbar({ numSelected, filterName, onFilterName, filterChecked, filterSetChecked, showFilter }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const menuItemDelete = () => {
    setIsOpen(false);
  //  props.selected(props.id, "delete");
  };

  const menuItemEdit = () => {
   setIsOpen(false);
   // props.selected(props.id, "edit");
  };


 

  const handleToggle = (value) => () => {
    const currentIndex = filterChecked.indexOf(value);
    const newChecked = [...filterChecked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    filterSetChecked(newChecked);
    setIsOpen(false);
  };

  console.log(filterChecked);

  return (
    <RootStyle
      sx={{
        paddingLeft:"0px",
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter'
        })
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <SearchStyle
          value={filterName}
          onChange={onFilterName}
          placeholder="Search user..."
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          }
        />
      )}

      {numSelected > 0 && showFilter &&
        <Tooltip title="Delete">
          <IconButton>
            <Icon icon={trash2Fill} />
          </IconButton>
        </Tooltip> }

      {numSelected == 0 && showFilter && <Tooltip title="Filter list" ref={ref}>
                <IconButton  onClick={() => setIsOpen(true)}>
                  <Icon icon={roundFilterList} />
                </IconButton>
              </Tooltip> }
              
      { showFilter && <Menu
              open={isOpen}
              anchorEl={ref.current}
              onClose={() => setIsOpen(false)}
              PaperProps={{
                sx: { width: 200, maxWidth: '100%' }
              }}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
              <MenuItem sx={{ color: 'text.secondary' }} onClick={handleToggle(0)}>
                <Checkbox
                  edge="start"
                  checked={filterChecked.indexOf(0) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': 0 }}
                />
                <ListItemText primary="Newsletter" primaryTypographyProps={{ variant: 'body2' }} />
              </MenuItem>

              <MenuItem sx={{ color: 'text.secondary' }} onClick={handleToggle(1)}>
                <Checkbox
                  edge="start"
                  checked={filterChecked.indexOf(1) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': 0 }}
                />
                <ListItemText primary="IsVisibleToOthers" primaryTypographyProps={{ variant: 'body2' }} />
              </MenuItem>

              <MenuItem sx={{ color: 'text.secondary' }} onClick={handleToggle(2)}>
                <Checkbox
                  edge="start"
                  checked={filterChecked.indexOf(2) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': 0 }}
                />
                <ListItemText primary="RidesVisibleToPublic" primaryTypographyProps={{ variant: 'body2' }} />
              </MenuItem>


            </Menu> }
    </RootStyle>
  );
}
